<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a v-if="record.status == '是'" @click="handleCopy(record)">重新发送</a>
        </span>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import { getAction, postAction } from '@/api/manage'
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'GoldStoneJpglistsVisitLogModal',
  components: {},
  // mixins:[JeecgListMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        city: { rules: [] },
        county: { rules: [] },
        createDate: { rules: [] },
      },
      url: {
        add: '/erp/supervisory/addDetail',
        list: '/erp/supervisory/detailList',
      },

      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '监控序号',
          align: 'center',
          dataIndex: 'controlId',
        },
        {
          title: '已推送',
          align: 'center',
          dataIndex: 'status',
        },
        {
          title: '推送类型',
          align: 'center',
          dataIndex: 'dealType',
        },
        {
          title: '接口人id',
          align: 'center',
          dataIndex: 'uerCode',
        },
        {
          title: '接收人名',
          align: 'center',
          dataIndex: 'username',
        },
        {
          title: '推送内容',
          align: 'center',
          dataIndex: 'hdText',
        },
        {
          title: '发送时间',
          align: 'center',
          dataIndex: 'sendTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],

      dataSource: [],

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },

      recordControlId: ''
    }
  },
  created() {},
  methods: {
    // add () {
    //   this.edit({});
    // },

    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
      // this.$nextTick(() => {
      //   this.form.setFieldsValue(pick(this.model,'jpFlowerColor','goldenStoneStoneseriesName','goldenStoneStonetypeName','province','city','county','createDate'))
      // })
      this.loadData(record)
    },

    loadData(record) {
      this.confirmLoading = true
      this.dataSource = [];
      if (record) {
        this.recordControlId = '';
        this.recordControlId = record.controlId;
      }
      getAction('/erp/supervisory/detailList', {
        controlId: this.recordControlId,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      })
        .then((res) => {
          this.confirmLoading = false
          this.dataSource = res.result.records || []
          this.ipagination.total = res.result.total || ''
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },

    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },

    handleCopy(record) {
      this.confirmLoading = true
      postAction('/erp/supervisory/addDetail', {
        controlId: record.controlId,
        dealType: record.dealType,
        hdText: record.hdText,
        // insertTime: record.insertTime,
        // sendTime: record.sendTime,
        username: record.username,
        status: '否',
        uerCode: record.uerCode,
      })
        .then((res) => {
          console.log(res.success, 'resresres')
          if (res.success) {
            this.$message.success('重新发送成功')
            if (this.dataSource.length != 10) {
              this.dataSource.push({
                ...record,
                status: '否',
              })
            }
            this.ipagination.total += 1
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },

    close() {
      this.$emit('close')
      this.visible = false
    },

    handleOk() {
      this.close()
    },

    handleCancel() {
      this.close()
    },
  },
}
</script>
